import { render, staticRenderFns } from "./UnionList.vue?vue&type=template&id=41193c76&"
import script from "./UnionList.vue?vue&type=script&lang=js&"
export * from "./UnionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports